export class ConsumedData {
    unitId: number;
    saleOrder: string;
    itemName: string;
    consumedQty: number;
    returnQty: number;
    unitName: string;
    saleOrderId:number;
    itemId:number;
    consumptionCode: string;
    poNumber?:string;
    itemCategory?:string;
    itemSubCategory?:string;
    itemCategoryId?:number;
    categoryName?:string;
    itemSubCategoryId?:number;
    itemSubCategoryName?:string;


}